<template>
    <div class="page">
        <ComponentRenderer v-for="component in components" :key="component.id" :component="component" />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { DEFAULT_HOME_PATH, DEFAULT_404_PATH } from '@/constants';
import { hashScrollMixin } from '@/mixins';

export default {
    name: 'Page',
    mixins: [hashScrollMixin],
    metaInfo() {
        const { title, description, image, isHome, noIndex, noFollow } = this.page ?? {};
        const gameName = this.game?.name;
        let titleTemplate = null;

        if (gameName) {
            titleTemplate = title ? '%s' : gameName;
        }

        const meta = [];
        let robots = [];
        if (description) {
            meta.push({ name: 'description', content: description });
            meta.push({ property: 'og:description', content: description });
        }
        if (image) {
            meta.push({ property: 'og:image', content: image });
        }
        if (noIndex) {
            robots.push('noindex');
        }
        if (noFollow) {
            robots.push('nofollow');
        }
        if (robots.length) {
            meta.push({ name: 'robots', content: robots.join() });
        }

        const link = [];
        if (isHome && this.$route.path !== '/') {
            link.push({ rel: 'canonical', href: window.location.protocol + '//' + window.location.host + '/' });
        }

        if (this.$store.getters.gameId === 'abebaf35-8962-4f8b-a701-3424fb93c466') {
            link.push({
                rel: 'icon',
                type: 'image/svg+xml',
                href: window.location.protocol + '//' + window.location.host + '/' + 'favicon.svg',
            });
        } else {
            link.push({
                rel: 'icon',
                type: 'image/svg+xml',
                href: window.location.protocol + '//' + window.location.host + '/' + 'favicon-kwf.svg',
            });
        }

        const { gtm_id } = this.$store.getters.socialData;

        const script = [];
        if (gtm_id) {
            script.push({ src: `https://www.googletagmanager.com/gtag/js?id=${gtm_id}`, async: true });
            script.push({
                vmid: 'gtag-snippet',
                innerHTML: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());

                    gtag('config', '${gtm_id}');
                `,
            });
        }

        return {
            title,
            titleTemplate, // All titles will be injected into this template
            meta,
            link,
            script,
            __dangerouslyDisableSanitizersByTagID: {
                'gtag-snippet': ['innerHTML'],
            },
        };
    },
    computed: {
        homePath() {
            return this.homePage?.path || DEFAULT_HOME_PATH;
        },
        errorPath() {
            return this.errorPage?.path || DEFAULT_404_PATH;
        },
        path() {
            return this.$route?.params?.path || this.homePath;
        },
        page() {
            return this._page(this.path) || this._page(this.errorPath);
        },
        components() {
            return this.page?.components;
        },
        orderId() {
            return this.$route.query.order_id;
        },
        ...mapState(['game', 'pages']),
        ...mapGetters(['homePage', 'errorPage']),
        ...mapGetters({ _page: 'page' }),
    },
};
</script>
